import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import "./assets/scss/style.scss";
import VueDOMPurifyHTML from "vue-dompurify-html";
// 引入 jQuerynp
import $ from "jquery";
// 将 jQuery 挂载到 Vue 的原型上，这样在组件中可以通过 this.$ 来使用
Vue.prototype.$ = $;
Vue.config.productionTip = false;

Vue.use(ElementUI);

// 默认配置（可选）
Vue.use(VueDOMPurifyHTML, {
  default: {
    // 允许的标签（默认包含 <a>，但需显式排除 href）
    ALLOWED_TAGS: ["a", "p", "span"],
    // 允许的属性列表（不包含 href）
    ALLOWED_ATTR: ["class", "title"],
    // 强制禁止的属性（可选，双重保险）
    FORBID_ATTR: ["href"],
  },
});
new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
